/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class QrDialog extends NoboxEntityDialog<any, any> {
        protected form = new QrForm(this.idPrefix);

        constructor() {
            super();
        }
        protected updateTitle(): void {
            super.updateTitle();
        }
        protected updateInterface() {
            super.updateInterface();
            var Account = Q.getLookup("Nobox.AccountLookup").itemById[this.form.AccountId.value] as AccountRow;
            if (Account.Channel == 1) {
                this.form.QrCodeImgBase64.getGridField().html(`<div class="auth-form qr" style="overflow-x:hidden;">
            <div class="row"><h3 class="text-center"><img src="${Q.resolveUrl("~/ds/img/whatsapp.png") }" style="width:30px;">&nbsp; WhatsApp</h3></div>
            <div class="text-center text-secondary fw-bold">${Account.Name}</div>
            <div class="text-center mb-4 mt-4">
                <img src="${this.form.QrCodeImgBase64.value}" style="width:264px;border: white solid 5px;">
            </div>
            <ol style="max-width:fit-content;margin-left: 17px;list-style:auto;" start="1">
                <li><span>Open WhatsApp on your phone</span></li>
                <li><span>Tap <b>Menu <i class="fas fa-ellipsis-v"></i></b> or <b>Settings</b> and select <b>Linked Device</b></span></li>
                <li><span>Tap <b>Linked Device</b></span></li>
                <li><span>Point your phone at this screen to scan the code</span></li>
            </ol>
            </div>`)
            } else if (Account.Channel == 2) {
                this.form.QrCodeImgBase64.getGridField().html(`<div class="auth-form qr" style="overflow-x:hidden;">
            <div class="row"><h3 class="text-center"><img src="${Q.resolveUrl("~/ds/img/telegram.png")}" style="width:25px;">&nbsp; Telegram</h3></div
            <div class="text-center text-secondary fw-bold">${Account.Name}</div>
            <div class="text-center mb-4 mt-4">
                <img src="${this.form.QrCodeImgBase64.value}" style="width:264px;border: white solid 5px;">
            </div>
            <ol style="max-width:fit-content;margin-left: 17px;list-style:auto;" start="1">
                <li><span>Open Telegram on your phone</span></li>
                <li><span>Go to <b>Settings</b> → <b>Devices</b> → <b>Link Desktop Device</b></span></li>
                <li><span>Point your phone at this screen to confirm login</span></li>
            </ol>
            </div>`)
            }
        }
        protected getToolbarButtons() {
            return [];
        }
        dialogOpen() {
            super.dialogOpen();

            $(".s-Nobox-Nobox-QrDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Scan This QR");
            Q.Router.replace("");

            var interClose = setInterval(() => {
                super.dialogClose();
                clearInterval(interClose);
            },30000);
        }
    }
}